import React, { useEffect, createElement } from 'react';
import { CheckCircleIcon, CalendarIcon, ClockIcon, UserIcon } from 'lucide-react';
export function BookCall() {
  useEffect(() => {
    // Load Calendly widget script
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      // Cleanup script on unmount
      document.body.removeChild(script);
    };
  }, []);
  const testimonials = [{
    quote: 'It took the headache out of recruiting and gave me my time back. In our first month, we brought on eight new reps. Three months later, six of them are still here and producing. We are now the top office in the company.',
    author: 'Nolan, Market Owner, Elite Windows'
  }, {
    quote: "They helped us hire nearly 100 new sales reps in one season, and many are now among our top performers. I have confidence knowing I don't just have a recruiting vendor. I have a true business partner.",
    author: 'Alden, Executive, Premier Roofing'
  }, {
    quote: 'They helped us tighten our back-end so we could grow based on real, reliable, predictable systems instead of hopes, dreams, and shoestrings. We stopped second-guessing our training and started keeping the right people.',
    author: 'Russell, VP of Sales, Shared Solar Advisors'
  }];
  return <div className="pt-32 pb-16 min-h-screen bg-gray-50 overflow-x-hidden" data-id="element-1204">
      <div className="container-custom px-4 sm:px-6" data-id="element-1205">
        <div className="max-w-6xl mx-auto" data-id="element-1206">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12" data-id="element-1207">
            {/* Left: Content */}
            <div className="w-full" data-id="element-1208">
              <div className="flex justify-center mb-6" data-id="element-1209">
                <div className="inline-block bg-slate/10 text-slate px-4 py-2 rounded text-sm font-semibold" data-id="element-1210">
                  Strategy Call
                </div>
              </div>

              <h1 className="mb-6" data-id="element-1211">Let's Map Out Your Recruiting System</h1>

              <p className="text-body-large mb-8 leading-relaxed" data-id="element-1212">
                This is not a high-pressure sales pitch. It is a working
                session. We will look at your current recruiting, find the
                holes, and see if the HIRE Advantage is the right fix.
              </p>

              {/* What to Expect */}
              <div className="bg-white rounded p-6 sm:p-8 shadow-lg border border-gray-200 mb-8" data-id="element-1213">
                <h3 className="mb-4 flex items-center" data-id="element-1214">
                  <CalendarIcon className="h-6 w-6 text-slate mr-3 flex-shrink-0" data-id="element-1215" />
                  What Happens On the Call
                </h3>
                <p className="mb-6 leading-relaxed" data-id="element-1216">
                  During this session, we will:
                </p>

                <ul className="space-y-3 mb-6" data-id="element-1217">
                  {['Audit Your Process: Deep-dive into how you currently hire and train.', 'Find the Leaks: Identify where you are losing reps and money.', 'Build the Map: Outline what the HIRE Advantage would look like for you.', 'Check the Fit: We will give you an honest "yes" or "no" on if we can help.'].map((item, index) => <li key={index} className="flex items-start" data-id="element-1218">
                      <CheckCircleIcon className="h-5 w-5 text-slate flex-shrink-0 mr-3 mt-0.5" data-id="element-1219" />
                      <span className="text-sm" data-id="element-1220">{item}</span>
                    </li>)}
                </ul>

                <p className="font-medium" data-id="element-1221">
                  You will walk away knowing exactly what is broken and how to
                  fix it.
                </p>
              </div>

              {/* Call Details */}
              <div className="grid grid-cols-2 gap-4 mb-8" data-id="element-1222">
                <div className="bg-gray-100 rounded p-4" data-id="element-1223">
                  <ClockIcon className="h-6 w-6 text-slate mb-2" data-id="element-1224" />
                  <p className="text-sm" data-id="element-1225">Duration</p>
                  <p className="font-bold text-navy" data-id="element-1226">45–60 minutes</p>
                </div>
                <div className="bg-gray-100 rounded p-4" data-id="element-1227">
                  <UserIcon className="h-6 w-6 text-slate mb-2" data-id="element-1228" />
                  <p className="text-sm" data-id="element-1229">Who Attends</p>
                  <p className="font-bold text-navy" data-id="element-1230">
                    You + Any Partners or Executives
                  </p>
                </div>
              </div>

              {/* Suggested to Bring */}
              <div className="bg-slate/5 rounded p-6 border border-slate/20 mb-8" data-id="element-1231">
                <p className="font-semibold text-navy mb-3" data-id="element-1232">Bring:</p>
                <p data-id="element-1233">Your current team size and growth goals.</p>
              </div>

              {/* Testimonials */}
              <div className="space-y-4 mb-8" data-id="element-1234">
                {testimonials.map((testimonial, index) => <div key={index} className="bg-navy/5 border-l-4 border-slate p-4 sm:p-6 rounded" data-id="element-1235">
                    <p className="italic mb-2 text-sm" data-id="element-1236">"{testimonial.quote}"</p>
                    <p className="text-sm font-semibold" data-id="element-1237">
                      — {testimonial.author}
                    </p>
                  </div>)}
              </div>

              {/* Important Notes */}
              <div className="bg-white rounded p-6 border-2 border-gray-200 shadow-md" data-id="element-1238">
                <h3 className="font-semibold mb-4" data-id="element-1239">Important Notes</h3>
                <ul className="space-y-3" data-id="element-1240">
                  <li className="flex items-start" data-id="element-1241">
                    <span className="text-slate mr-2 flex-shrink-0 mt-1" data-id="element-1242">
                      •
                    </span>
                    We are selective.
                  </li>
                  <li className="flex items-start" data-id="element-1243">
                    <span className="text-slate mr-2 flex-shrink-0 mt-1" data-id="element-1244">
                      •
                    </span>
                    If we aren't the right solution, we will tell you.
                  </li>
                  <li className="flex items-start" data-id="element-1245">
                    <span className="text-slate mr-2 flex-shrink-0 mt-1" data-id="element-1246">
                      •
                    </span>
                    This protects your time and ours.
                  </li>
                </ul>
              </div>
            </div>

            {/* Right: Calendly Embed */}
            <div className="w-full" data-id="element-1247">
              <div className="bg-white rounded p-6 sm:p-8 shadow-2xl border border-gray-200 lg:sticky lg:top-24" data-id="element-1248">
                <h3 className="mb-6" data-id="element-1249">Schedule Your Strategy Call</h3>

                {/* Calendly Inline Widget */}
                <div className="calendly-inline-widget w-full" data-url="https://calendly.com/d/crp7-97v-yyv/the-hire-advantage-strategy-call?hide_gdpr_banner=1&primary_color=64748B" style={{
                minWidth: '100%',
                width: '100%',
                height: '700px'
              }} data-id="element-1250"></div>
              </div>
            </div>
          </div>

          {/* Final CTA Below Calendar */}
          <div className="mt-16 max-w-3xl mx-auto text-center" data-id="element-1251">
            <h2 className="mb-6" data-id="element-1252">Ready to Get Clarity?</h2>
            <p className="text-body-large mb-8 leading-relaxed" data-id="element-1253">
              Schedule your strategy call above. Let's build your system.
            </p>
            <a href="/how-it-works" className="inline-block border-2 border-navy text-navy hover:bg-navy hover:text-white font-bold px-8 py-4 rounded transition-colors" data-id="element-1254">
              See How It Works →
            </a>
          </div>
        </div>
      </div>
    </div>;
}